// @mui
import {
  Card,
  CardContent,
  Typography,
  Stack,
} from '@mui/material';
// hooks
import SvgIconStyle from '../../components/SvgIconStyle';

// ---------

export default function RequestOtherTimeCard({ candidate }) {
  return (
    <>
    <Card
      sx={{
        mb: 3,
        backgroundColor: 'background.neutral',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <CardContent
        sx={{ p: 3 }}
      >
        <Stack direction="row" spacing={1.5}>
          <SvgIconStyle src={`/icons/icon-chat-bubble-dots-mono.svg`} sx={{ color: "text.secondary" }} />
          <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {candidate.time_comment}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
    </>
  )
}

